import { ModuleConfig } from "../../types/ModuleConfig";

const vapiModuleConfig: ModuleConfig = {
  id: "vapi",
  name: "Vapi Voice AI",
  description: "AI-powered voice calling with Vapi",
  icon: "🤖",
  version: "1.0.0",
  enabled: true,
  category: "communication",
  order: 11,
  navigation: [
    {
      path: "/vapi",
      label: "Voice AI Dashboard",
      icon: "📊",
    },
    {
      path: "/vapi/web-call",
      label: "Web Call",
      icon: "📞",
    },
    {
      path: "/vapi/call-logs",
      label: "Call Logs",
      icon: "📋",
    },
    {
      path: "/vapi/todos",
      label: "Implementation Todos",
      icon: "✅",
    },
  ],
  permissions: {
    view: ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "TENANT_USER", "VAPI_USER", "VAPI_ADMIN", "ADMIN"],
    create: ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "VAPI_ADMIN", "ADMIN"],
    edit: ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "VAPI_ADMIN", "ADMIN"],
    delete: ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "ADMIN"],
  },
  quickActions: [
    {
      label: "Start Web Call",
      path: "/vapi/web-call",
      icon: "📞",
      description: "Start an AI voice call from your browser",
    },
    {
      label: "View Call Logs",
      path: "/vapi/call-logs",
      icon: "📋",
      description: "View your call history and transcripts",
    },
  ],

  // 📝 CHANGELOG
  changelog: [
        {
            version: "1.0.0",
            releaseDate: "2025-11-22",
            title: "Stable Release - Production Ready",
            features: [
                "✅ Production-ready AI voice calling platform",
                "✅ Vapi API integration for voice AI",
                "✅ Browser-to-browser voice calls",
                "✅ Call transcription and logging",
                "✅ Workflow automation integration",
                "✅ Voice AI configuration management",
                "✅ Role-based permissions (VAPI_USER, VAPI_ADMIN)"
            ],
            notes: "Official stable release with comprehensive voice AI capabilities."
        },
        {
            version: "0.8.0",
            releaseDate: "2025-09-30",
            title: "Tenant Module Separation",
            features: [
                "✨ Separated tenant and admin permissions (8 lines)",
                "✨ Enhanced TENANT_MASTER_ADMIN controls",
                "✨ Improved multi-tenant isolation",
                "✨ Better permission granularity"
            ],
            notes: "Tenant module architecture improvements for better isolation."
        },
        {
            version: "0.7.0",
            releaseDate: "2025-09-21",
            title: "Video Management & Enhanced Navigation",
            features: [
                "✨ Enhanced CallDetails navigation (2 lines)",
                "✨ Improved CallLogs display (2 lines)",
                "✨ VapiConfigForm enhancements (2 lines)",
                "✨ VapiDashboard improvements (2 lines)",
                "✨ VapiTodos navigation (2 lines)",
                "✨ WebCall functionality updates (2 lines)",
                "✨ Workflows navigation (2 lines)"
            ],
            notes: "Navigation and video management integration across all Vapi components."
        },
        {
            version: "0.6.0",
            releaseDate: "2025-09-20",
            title: "Module System & Theme Migration",
            features: [
                "✨ Full light/dark mode support (32 lines)",
                "✨ Enhanced VapiDashboard theme (16 lines)",
                "✨ Module import improvements (6 lines)",
                "✨ Component theme consistency"
            ],
            notes: "Complete theme system and modern module architecture."
        },
        {
            version: "0.5.0",
            releaseDate: "2025-08-25",
            title: "Call Details & Enhanced Logging",
            features: [
                "✅ Created CallDetails component (527 lines)",
                "✨ Enhanced CallLogs integration (23 lines)",
                "✨ Refactored CallDetails for performance (90 lines)",
                "✨ Native Date formatting (37 lines)",
                "✨ Fixed button visibility (18 lines)",
                "✨ Fixed missing dependencies (1 line)",
                "✨ Open call details in new tab"
            ],
            notes: "Comprehensive call details and logging improvements."
        },
        {
            version: "0.4.0",
            releaseDate: "2025-08-25",
            title: "Web Call Implementation",
            features: [
                "✨ Refactored WebCall component (241 lines)",
                "✨ Browser-to-browser voice calling",
                "✨ Improved call controls",
                "✨ Enhanced audio quality settings",
                "✨ Better error handling"
            ],
            notes: "Complete web call functionality for in-browser voice AI."
        },
        {
            version: "0.3.0",
            releaseDate: "2025-08-24",
            title: "Workflows & Advanced Call Management",
            features: [
                "✅ Created Workflows component (445 lines)",
                "✨ Enhanced CallLogs with 911 insertions",
                "✨ Email management integration",
                "✨ Markdown support with remark-gfm",
                "✨ Improved VapiDashboard (11 lines)",
                "✨ Enhanced VapiTodos (8 lines)"
            ],
            notes: "Workflow automation and advanced call management features."
        },
        {
            version: "0.2.0",
            releaseDate: "2025-08-24",
            title: "Enhanced User Experience",
            features: [
                "✨ Refactored VapiTodos component (110 lines)",
                "✨ Improved WebCall UX (133 lines)",
                "✨ Better component organization",
                "✨ Enhanced error messaging",
                "✨ Improved loading states"
            ],
            notes: "Major UX improvements across all Vapi components."
        },
        {
            version: "0.1.0",
            releaseDate: "2024-08-24",
            title: "Initial Vapi Voice AI System",
            features: [
                "✅ Created VapiTodos component (928 lines)",
                "✅ Created WebCall component (494 lines)",
                "✅ Created VapiConfigForm component (349 lines)",
                "✅ Created CallLogs component (344 lines)",
                "✅ Created VapiDashboard component (292 lines)",
                "✅ Module configuration and routing (54 lines)",
                "✅ Created index file (19 lines)",
                "✅ Vapi API integration",
                "✅ Voice AI assistant creation",
                "✅ Call transcription and logging"
            ],
            notes: "Initial implementation with 2,480 lines of voice AI code."
        }
    ],

    // 🗺️ ROADMAP
    roadmap: []

};

export default vapiModuleConfig;